import * as Types from '../../../../../__generated__/base.gql';

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type EpocusGenerateImagingAssetUrlQueryVariables = Types.Exact<{
  input: Types.ImagingAssetUrlInput;
}>;


export type EpocusGenerateImagingAssetUrlQuery = { readonly __typename?: 'Query', readonly generateImagingAssetUrl: { readonly __typename?: 'ImagingAssetUrl', readonly url?: string | null } };


export const EpocusGenerateImagingAssetUrlDocument = gql`
    query EpocusGenerateImagingAssetUrl($input: ImagingAssetUrlInput!) {
  generateImagingAssetUrl(input: $input) {
    url
  }
}
    `;

/**
 * __useEpocusGenerateImagingAssetUrlQuery__
 *
 * To run a query within a React component, call `useEpocusGenerateImagingAssetUrlQuery` and pass it any options that fit your needs.
 * When your component renders, `useEpocusGenerateImagingAssetUrlQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useEpocusGenerateImagingAssetUrlQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useEpocusGenerateImagingAssetUrlQuery(baseOptions: Apollo.QueryHookOptions<EpocusGenerateImagingAssetUrlQuery, EpocusGenerateImagingAssetUrlQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<EpocusGenerateImagingAssetUrlQuery, EpocusGenerateImagingAssetUrlQueryVariables>(EpocusGenerateImagingAssetUrlDocument, options);
      }
export function useEpocusGenerateImagingAssetUrlLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<EpocusGenerateImagingAssetUrlQuery, EpocusGenerateImagingAssetUrlQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<EpocusGenerateImagingAssetUrlQuery, EpocusGenerateImagingAssetUrlQueryVariables>(EpocusGenerateImagingAssetUrlDocument, options);
        }
export type EpocusGenerateImagingAssetUrlQueryHookResult = ReturnType<typeof useEpocusGenerateImagingAssetUrlQuery>;
export type EpocusGenerateImagingAssetUrlLazyQueryHookResult = ReturnType<typeof useEpocusGenerateImagingAssetUrlLazyQuery>;
export type EpocusGenerateImagingAssetUrlQueryResult = Apollo.QueryResult<EpocusGenerateImagingAssetUrlQuery, EpocusGenerateImagingAssetUrlQueryVariables>;